<script lang="ts">
import { defineComponent, PropType, inject, watch } from 'vue'
import SelectorForm from '@/components/form/SelectorForm.vue'

export default defineComponent({
  name: 'SelectorPositionLevel',

  components: {
    SelectorForm,
  },

  props: {
    positionLevel: {
      type: Object as PropType<InputText>,
      required: true,
    },

    namespace: {
      type: String,
      default: '',
    },

    defaultSelectorLabel: {
      type: String,
      default: '選択してください',
    },

    defaultSelectorValue: {
      type: String,
      default: '',
    },

    header: {
      type: String,
      default: '役職',
    },
  },

  emits: [
    'update:positionLevel',
  ],

  setup(props, { emit }) {
    const POSITION_LEVELS = inject<string[]>('POSITION_LEVELS')!

    // 選択肢に存在しない値の場合は空の値で再設定
    // ※ 古いユーザの場合、古い区分で値を保持している場合があり、その場合は強制的に再設定させる。
    watch(() => props.positionLevel.value, () => {
      if (props.positionLevel.value && !POSITION_LEVELS.includes(props.positionLevel.value)) {
        emit('update:positionLevel', '')
      }
    })

    const emitValue = (value: string) => {
      if (typeof value === 'string') {
        emit('update:positionLevel', value)
      } else {
        emit('update:positionLevel', '')
      }
    }

    return {
      // constants
      POSITION_LEVELS,

      // methods
      emitValue,
    }
  }
})
</script>

<template>
  <SelectorForm
    :model-value="positionLevel.value"
    :items="POSITION_LEVELS"
    :default-selector-label="defaultSelectorLabel"
    :default-selector-value="defaultSelectorValue"
    :namespace="namespace"
    :name="positionLevel.name"
    :header="header"
    :validation-scheme="positionLevel.validationScheme"
    @update:model-value="emitValue($event)" />
</template>
